import React from 'react';
import { endOfYear, startOfYear } from 'date-fns';
import CustomDatePicker from '../../../../../components/CustomDatePicker';
import { getYear } from '../../utils';

export function DateRange({
  date_from, date_to, onChange, minDate, isCleared, setIsCleared,
}) {
  const fromYear = getYear(date_from);
  const toYear = getYear(date_to);

  const toYearBounds = toYear
    ? {
      minDate: startOfYear(new Date(toYear, 0, 1)),
      maxDate: new Date(date_to),
    }
    : {};

  const fromYearBounds = fromYear
    ? {
      minDate: new Date(date_from),
      maxDate: endOfYear(new Date(fromYear, 0, 1)),
    }
    : {};

  return (
    <>
      <CustomDatePicker
        sx={{ mr: '10px', minWidth: '250px' }}
        label="Начало:"
        name="date_from"
        value={date_from}
        onChange={onChange}
        clearInvalidDate
        isCleared={isCleared}
        setIsCleared={setIsCleared}
        minDate={minDate}
        {...toYearBounds}
      />
      <CustomDatePicker
        sx={{ minWidth: '250px' }}
        label="Окончание:"
        name="date_to"
        value={date_to}
        onChange={onChange}
        clearInvalidDate
        isCleared={isCleared}
        setIsCleared={setIsCleared}
        minDate={minDate}
        {...fromYearBounds}
      />
    </>
  );
}
